import ClientsCard from "./ClientsCard";

export default ClientsCard;
